import { AdminHttpClient } from "@/app/api/AdminHttpClient"
import { DomainResponse } from "@/types/domain"

const getDomains = async () => {
  const res = await AdminHttpClient.get<DomainResponse>("/api/websites", {
    skipDomainFilter: true,
  })
  return res.data
}

export default getDomains
